<template>
    <div class="hts-layout-default">
        <router-view />
    </div>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig().public
useHead({
  title: config.appName
})
</script>
